import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory, faHandHoldingUsd, faUserAlt, faMale, faSchool } from '@fortawesome/free-solid-svg-icons';

const advantages = [
  { icon: faHistory, text: "Правильне та своєчасне подання фінансової та податкової звітності" },
  { icon: faHandHoldingUsd, text: "Оптимальна система оподаткування" },
  { icon: faUserAlt, text: "Он-лайн навчання та підвищення кваліфікації" },
  { icon: faMale, text: "Бухгалтерський супровід 24/7" },
  { icon: faSchool, text: "Навчання бухгалтера з нуля" },
];

function IconsBuh() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll('.buh-adv');
            items.forEach((item, i) => {
              setTimeout(() => {
                item.style.opacity = '1';
                item.style.transform = 'translateY(0)';
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} style={{
      padding: '100px 24px',
      background: 'linear-gradient(180deg, #0a0a0f 0%, #0d1a0e 100%)',
    }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(22px, 3.5vw, 36px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 50,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          З нами ви <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>зможете</span>
        </h2>

        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 28,
        }}>
          {advantages.map((item, i) => (
            <div key={i} className="buh-adv" style={{
              opacity: 0,
              transform: 'translateY(30px)',
              transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              padding: 20,
              width: 180,
              cursor: 'default',
            }}
            onMouseOver={e => {
              const icon = e.currentTarget.querySelector('.icon-circle');
              if (icon) {
                icon.style.boxShadow = '0 0 30px rgba(22,183,36,0.4)';
                icon.style.borderColor = '#16b724';
              }
            }}
            onMouseOut={e => {
              const icon = e.currentTarget.querySelector('.icon-circle');
              if (icon) {
                icon.style.boxShadow = 'none';
                icon.style.borderColor = 'rgba(22,183,36,0.3)';
              }
            }}
            >
              <div className="icon-circle" style={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                border: '2px solid rgba(22,183,36,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 16,
                background: 'rgba(22,183,36,0.05)',
                transition: 'all 0.4s ease',
              }}>
                <FontAwesomeIcon icon={item.icon} style={{ color: '#4dc247', fontSize: 26 }} />
              </div>
              <span style={{
                color: 'rgba(255,255,255,0.7)',
                fontSize: 13,
                fontWeight: 500,
                lineHeight: 1.5,
              }}>
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default IconsBuh;
